import type { DefLookup } from "../catalog";
import { computeIsolatorModelBoundary } from "../dc-isolators";
import type { Issue, System } from "../types";

/** Output isolation is modeled; directional charging allocation is not. Do
 * not silently replace a fabricated battery bank with allegedly verified zero
 * charging or a complete cable-current bound. */
export function detectUnsupportedBatteryIsolator(system: System, lookup: DefLookup): Issue[] {
  const boundary = computeIsolatorModelBoundary(system, lookup);
  if (!boundary.nodeIds.size) return [];
  return [{
    code: "battery-isolator-model-unverified", severity: "warning",
    nodeIds: [...boundary.nodeIds].sort(), cableIds: [...boundary.cableIds].sort(),
    title: { key: "diag.battery-isolator-model-unverified.title" },
    message: { key: "diag.battery-isolator-model-unverified.message" },
    fix: { key: "diag.battery-isolator-model-unverified.fix" },
  }];
}
